import { render, staticRenderFns } from "./controlesVehi.vue?vue&type=template&id=3179d2d2"
import script from "./controlesVehi.vue?vue&type=script&lang=js"
export * from "./controlesVehi.vue?vue&type=script&lang=js"
import style0 from "./controlesVehi.vue?vue&type=style&index=0&id=3179d2d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports